module.exports = __webpack_public_path__ + "static/CV-8f40f5462cc56bcaca1d929068e88ac9.pdf";